export {default as ReleaseNotes} from './ReleaseNotes.connect';
